



























































































































import { Meta } from "@/store/meta"
import { Server } from "@/store/server"
import { mixins } from "vue-class-component"
import { Component } from "vue-property-decorator"
import { getModule } from "vuex-module-decorators"
import { Dictionary } from '@/mixins/dictionary'
@Component({
})
export default class Dashboard extends mixins(Dictionary) {

  async mounted() {
    await getModule(Server).getLoginInfo(this.accessToken)

    if(this.loginInfo.plan != 'free'){
      await getModule(Server).getBoccoChannel()
    }
  }

  get meta() {
    return getModule(Meta)
  }

  get isViewer() {
    return this.meta.isViewer
  }

  get accessToken() {
    return this.meta.accessToken
  }

  get refreshToken() {
    return this.meta.refreshToken
  }

  get xChannelServices() {
    const channel = getModule(Server).boccoChannel
    if (channel == null) {
      return []
    }
    return channel.services
  }

  get loginInfo() {
    return getModule(Server).loginInfo
  }

  copyToClipBoard(secretKey: string) {
    navigator.clipboard.writeText(secretKey);
  }
}
